export enum OSType {
    ANDROID = "ANDROID",
    IOS = "IOS",
    WINDOWS = "WINDOWS",
    MAC = "MAC",
    WINDOWS_PHONE = "WINDOWS_PHONE",
}

export enum AppType {
    PWA = "PWA",
    BROWSER = "BROWSER",
}

export const getOSType = (): OSType | null => {
    const userAgent = navigator.userAgent || navigator.vendor;

    // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
        return OSType.WINDOWS_PHONE;
    }

    if (/android/i.test(userAgent)) {
        return OSType.ANDROID;
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    // @ts-ignore
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return OSType.IOS;
    }

    if (/windows nt/i.test(userAgent)) {
        return OSType.WINDOWS;
    }

    if (/mac/i.test(userAgent)) {
        return OSType.MAC;
    }

    return null;
}

export enum BrowserType {
    SAFARI = "SAFARI",
    CHROME = "CHROME",
    FIREFOX = "FIREFOX",
    OPERA = "OPERA",
    EDGE = "EDGE",
    IE = "IE",
}

export const getBrowserType = (): BrowserType | null => {
    const userAgent = navigator.userAgent || navigator.vendor;

    if (/OPR/i.test(userAgent) || /Opera/i.test(userAgent)) {
        return BrowserType.OPERA;
    }

    if (/Firefox/i.test(userAgent)) {
        return BrowserType.FIREFOX;
    }

    if (/Edg/i.test(userAgent)) {
        return BrowserType.EDGE;
    }

    if (/Chrome/i.test(userAgent) || /CriOS/i.test(userAgent)) {
        return BrowserType.CHROME;
    }

    if (/Safari/i.test(userAgent)) {
        return BrowserType.SAFARI;
    }

    if (/MSIE/i.test(userAgent) || /Trident/i.test(userAgent)) {
        return BrowserType.IE;
    }

    return null;
}

export const isPWA = (): boolean => {
    return window.matchMedia('(display-mode: standalone)').matches;
}

export enum DeviceOrientation {
    PORTRAIT = "portrait",
    LANDSCAPE = "landscape",
}

export const getDeviceOrientation = (): DeviceOrientation | null => {
    // Modern approach
    if (typeof window.matchMedia === "function") {
        if (window.matchMedia("(orientation: portrait)").matches) {
            return DeviceOrientation.PORTRAIT;
        } else if (window.matchMedia("(orientation: landscape)").matches) {
            return DeviceOrientation.LANDSCAPE;
        }
    }
    // Fallback: compare width and height
    if (window.innerWidth && window.innerHeight) {
        return window.innerWidth > window.innerHeight ? DeviceOrientation.LANDSCAPE : DeviceOrientation.PORTRAIT;
    }
    return null;
}

export const isDesktop = (): boolean => {
    return !/Mobi|Android/i.test(navigator.userAgent);
}

export const hasCamera = (): boolean => {
    return !!(
        navigator.mediaDevices &&
        navigator.mediaDevices.getUserMedia &&
        typeof navigator.mediaDevices.getUserMedia === "function"
    );
}